export const trimObjectValues = (obj) => {
    for (let key in obj) {
        if (obj[key] && typeof obj[key] == "string") {
            obj[key] = obj[key].trim()
        }
    }
    return obj
}

export const removeEmptyObjectAttributes = (obj) => {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj
  }